import React, { memo } from 'react';
import CapitalSocialCardBase from '../../../../../components/organisms/EmpresaIndicadores/CapitalSocialCard';
import { useEmpresasContext } from '../../../../../contexts/EmpresasContext';

const CapitalSocialCard = memo(() => {
  const { state, actions } = useEmpresasContext();
  const xHistorico = state?.historico?.cs || [];

  return (
    <CapitalSocialCardBase
      pessoaId={state?.pessoa?.pessoa_id}
      pessoaNome={state?.pessoa?.pessoa_fantasia || state?.pessoa?.pessoa}
      historico={xHistorico}
      isLoading={state?.isPageLoading}
      actions={{
        formatNumber: (pValue, pCurrency = false, pDecimals = 0) =>
          actions.formatNumber(pValue, state.showPrecise, pCurrency, pDecimals, null)
      }}
      onOpenHistory={actions.handleChartVariantChange}
    />
  );
});

export default CapitalSocialCard;
